import { Button } from '@components/Button';
import { Flex } from '@components/Flex';
import { themeColor, themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import styled from 'styled-components';
import Modal from 'react-modal';
import Carousel from 'nuka-carousel';

const CARD_DIMENSIONS = {
  width: '800px',
  height: '528px',
  belowSmMinHeight: '500px',
  belowSmMaxHeight: '95vh',
  belowSmMaxWidth: '84vw',
};

export const StyledButton = styled(Button)`
  margin-top: ${themeSpace(5)};
  width: fit-content;
  border-radius: ${themeSpace(6)};
  color: ${props => props.theme.colors.mono1};
  &:hover {
    background-color: ${themeColor('neutra5')};
  }
  &:active {
    background-color: ${themeColor('neutra6')};
  }
`;

export const StyledModal = styled(Modal)``;

export const StyledContainer = styled(Flex)`
  flex-direction: row;
  width: 100%;
  gap: ${themeSpace(7)};
  padding: 0 100px;
  ${themeMediaQuery('below_sm')} {
    align-items: center;
    padding: 0 ${themeSpace(6)};
  }
`;

export const StyledFlex = styled(Flex)`
  background-color: white;
  width: ${CARD_DIMENSIONS.width};
  height: ${CARD_DIMENSIONS.height};
  border-radius: ${themeSpace(5)};
  ${themeMediaQuery('below_sm')} {
    min-height: ${CARD_DIMENSIONS.belowSmMinHeight};
    height: auto;
    max-height: ${CARD_DIMENSIONS.belowSmMaxHeight};
    max-width: ${CARD_DIMENSIONS.belowSmMaxWidth};
  }
`;

export const StyledCarousel = styled(Carousel)`
  .one-registry-paging-dot {
    background-color: white;
    padding-right: ${themeSpace(3)};
    svg {
      scale: 1.3;
    }
  }
  .slider-control-bottomcenter {
    bottom: -10% !important;
    .paging-item > button {
      fill: ${themeColor('mono4')} !important;
      opacity: 1 !important;
    }
    .paging-item.active > button {
      fill: ${themeColor('mono1')} !important;
    }
  }
`;
